module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/videographer-11a26472d451b4f24f7a81f9640c9f32.webp";